import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  IconButton,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { withSnackbar } from "../../utils/SnackbarHOC";
import { theme } from "../../utils/Theme";
import { getAll, getListDataEspaceMission } from "../../services/MissionService";
import MissionsTable from "./Components/MissionsTable";
import "./Listermission.css";
import ModalMission from "./ModalMission";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AppButton, PageHeader, PageLayout } from "../../components/UI";

const Listermission = ({ snackbarShowMessage }) => {
  const location = useLocation();
  const history = useHistory();
  const priorities = ["1", "2", "3"];
  const searchParams = new URLSearchParams(location.search);
  const statutFromURL = searchParams.get("statut") ? searchParams.get("statut") : '910f357b-0b13-4f66-89a8-5c06964c1dcf'
  const clientsFromURL = searchParams.getAll("clients[]") ? searchParams.getAll("clients[]") : []
  const keyFromURL = searchParams.get("keyword") ? searchParams.get("keyword") : ""
  const [statut, setStatut] = useState(statutFromURL.toString())
  const [loadingListData, setLodingListData] = useState(true);
  const [listData, setListData] = useState({ societesClients: [], statutsMission: [] });
  const [clients, setClients] = useState(clientsFromURL);
  const [keyword, setKeyWord] = useState(keyFromURL.toString());
  const [reloadData, setReloadData] = useState(false);
  const [selectedPriorities, setSelectedPriorities] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const [clientType, setClientType] = useState('tous');
  const [filteredClients, setFilteredClients] = useState([]);

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setClientType(value);

    if (value === 'tous') {
      setFilteredClients(listData.societesClients);
    } else {
      const filtered = listData.societesClients.filter(
        (item) => item.statut === value
      );
      setFilteredClients(filtered);
    }
  };

  useEffect(() => {
    if (listData.societesClients.length) {
      setFilteredClients(listData.societesClients);
    }
  }, [listData]);

  const [missionData, setMissionData] = useState({
    data: [],
    isLoading: false,
    totalMissions: 0,
  });

  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  const resetParamsUrl = () => {
    const params = new URLSearchParams();
    params.append('statut', '910f357b-0b13-4f66-89a8-5c06964c1dcf');
    return params;
  }

  const getInitialParameters = () => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.toString()) return searchParams;
    return resetParamsUrl();
  };


  React.useEffect(() => {
    let active = true;
    (async () => {
      setLodingListData(true);
      try {
        const responseListData = await getListDataEspaceMission();
        if (!active) {
          return;
        }
        setListData({ societesClients: responseListData.data.societesClients, statutsMission: responseListData.data.statutMission });
        setLodingListData(false);
      } catch (error) {
        if (!active) {
          return;
        }
        snackbarShowMessage("Erreur de chargement des données des listes.", "error", 4000);
        setLodingListData(false);
      }
    })();

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showLoading = () => {
    setMissionData((prevState) => ({
      ...prevState,
      data: [],
      isLoading: true,
    }));
  }

  React.useEffect(() => {
    let active = true;

    const fetchData = async () => {
      showLoading();
      try {
        const params = getInitialParameters();
        params.set('limit', 10000);

        const { data } = await getAll(params);
        if (!active) return;
        setMissionData({
          isLoading: false,
          data: data.missions,
          totalMissions: data.count,
        });
      } catch (error) {
        snackbarShowMessage("Erreur de chargement des missions.", "error", 4000);
        setMissionData({
          isLoading: false,
        });
      }
    };
    fetchData();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData, location.search]);

  const updateURLParams = ({ clients, statut, keyword, priorities }) => {
    const params = new URLSearchParams();
    clients.forEach((value) => {
      params.append(`clients[]`, value);
    });
    priorities.forEach((priorite) => {
      params.append(`priorities[]`, priorite)
    })
    params.append('statut', statut);
    params.append("keyword", keyword);
    history.push(`/missions?${params.toString()}`);
  };

  const handleFilterByMissionState = (e) => {
    setStatut(e.target.value);
    updateURLParams({ clients: clients, statut: e.target.value, keyword, priorities: selectedPriorities });
  };

  const handleFilterByClients = (clients) => {
    setClients(clients.target.value);
    updateURLParams({ clients: clients.target.value, statut, keyword, priorities: selectedPriorities });
  };

  const handlePriorityChange = (event) => {
    const value = event.target.value;
    setSelectedPriorities(value);
    updateURLParams({ clients, statut, keyword, priorities: value });
  };

  const handleFilterByKeyword = () => {
    updateURLParams({ clients: clients, statut, keyword, priorities: selectedPriorities });
  };

  const editMission = (missionId, societeId) => {
    history.push({ pathname: `/societe/${societeId}/missions/${missionId}/update` });
  };

  return (
    <PageLayout>
      <PageHeader
        title="Liste des missions"
        count={missionData.totalMissions}
        actions={
          isSmMode ? (
            <IconButton
              title="Ajouter"
              onClick={() => setModalOpen(true)}
              sx={{ background: 'linear-gradient(135deg,#03407b,#02357a)', color: '#fff', borderRadius: '10px', '&:hover': { background: '#02357a' } }}
            >
              <AddIcon />
            </IconButton>
          ) : (
            <AppButton
              variant="primary"
              startIcon={<AddIcon sx={{ fontSize: 18 }} />}
              onClick={() => setModalOpen(true)}
            >
              Ajouter une mission
            </AppButton>
          )
        }
      />

      {modalOpen && <ModalMission setOpenModal={setModalOpen} />}

      <Box className="mission_content">
        <Card sx={{ p: '16px 24px', mb: 2, borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', background: '#fff', display: 'flex', alignItems: 'flex-end', gap: 3, flexWrap: 'wrap' }}>

          {/* Statut missions */}
          <Box sx={{ flex: 1, minWidth: 130 }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
              Statut missions
            </Typography>
            <FormControl variant="outlined" fullWidth size="small">
              {loadingListData ? (
                <Box display="flex" justifyContent="center"><CircularProgress size={20} /></Box>
              ) : (
                <Select name="statut" value={statut} onChange={(e) => handleFilterByMissionState(e)}>
                  {listData.statutsMission.map((s) => (
                    <MenuItem value={s.uuid} key={s.uuid}>{s.statut}</MenuItem>
                  ))}
                </Select>
              )}
            </FormControl>
          </Box>

          {/* Priorité */}
          <Box sx={{ flex: 1, minWidth: 150 }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
              Rechercher par priorité
            </Typography>
            <FormControl variant="outlined" fullWidth size="small">
              <Select multiple value={selectedPriorities} onChange={handlePriorityChange} renderValue={(s) => s.join(', ')}>
                {priorities.map((priority) => (
                  <MenuItem key={priority} value={priority}>
                    <Checkbox checked={selectedPriorities.indexOf(priority) > -1} />
                    <ListItemText primary={priority} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Mot-clé */}
          <Box sx={{ flex: 1.2, minWidth: 160 }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
              Consultant(e), N° ou mot-clé
            </Typography>
            <TextField
              name="keyword" value={keyword} onChange={(e) => setKeyWord(e.target.value)}
              variant="outlined" autoComplete="off" fullWidth size="small" placeholder="N° ou mot-clé"
              onBlur={handleFilterByKeyword}
              onKeyDown={(e) => { if (e.key === 'Enter') handleFilterByKeyword(); }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px', backgroundColor: '#f8fafc', fontSize: '1rem',
                  '& fieldset': { borderColor: '#e2e8f0' },
                  '&:hover fieldset': { borderColor: '#7fb3d3' },
                  '&.Mui-focused fieldset': { borderColor: '#03407b' },
                },
              }}
            />
          </Box>

          {/* Filtrer clients */}
          <Box sx={{ flex: 1, minWidth: 180 }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
              Filtrer clients
            </Typography>
            <RadioGroup row aria-label="client-type" name="clientType" value={clientType} onChange={handleRadioChange}
              sx={{ gap: 1 }}>
              <FormControlLabel value="tous" control={<Radio size="small" />} label="Tous" sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }} />
              <FormControlLabel value="client" control={<Radio size="small" />} label="Client" sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }} />
              <FormControlLabel value="prospect" control={<Radio size="small" />} label="Prospect" sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }} />
            </RadioGroup>
          </Box>

          {/* Rechercher par clients */}
          <Box sx={{ flex: 1.2, minWidth: 160 }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
              Rechercher par clients
            </Typography>
            <FormControl variant="outlined" fullWidth size="small">
              {loadingListData ? (
                <Box display="flex" justifyContent="center"><CircularProgress size={20} /></Box>
              ) : (
                <Select multiple name="clients" value={clients} onChange={(e) => handleFilterByClients(e)}
                  renderValue={(selected) =>
                    filteredClients.filter((i) => selected.includes(i.uuid)).map((c) => c.nomSociete).join(', ')
                  }>
                  {filteredClients.map((client) => (
                    <MenuItem value={client.uuid} key={client.uuid}>
                      <Checkbox checked={clients.indexOf(client.uuid) > -1} />
                      <ListItemText primary={client.nomSociete.toUpperCase()} />
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FormControl>
          </Box>

        </Card>
        <Box className="missions_container">
          <MissionsTable
            missionData={missionData}
            editMission={editMission}
            snackbarShowMessage={snackbarShowMessage}
            onReload={() => setReloadData(prev => !prev)}
          />
        </Box>
      </Box>
    </PageLayout>
  );
};
export default withSnackbar(Listermission);